<template>
  <div class="overlay" v-show="showOverlay">
    <div class="overlayInner">
      <el-carousel trigger="click" :interval="0" arrow="always">
        <ul v-for="(img, idx) in carslImgs" :key="idx">
          <el-carousel-item>
            <el-image :src="img"> </el-image>
          </el-carousel-item>
        </ul>
      </el-carousel>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { Carousel, CarouselItem, Loading, Image, Icon } from "element-ui";
export default {
  name: "Carouseloverlay",
  props: {
    showOverlay: {
      type: Boolean,
      default: false,
    },
    carslImgs: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Loading.name]: Loading,
    [Image.name]: Image,
    [Icon.name]: Icon,
  },
  created() {},
  methods: {},
};
</script>
<style>
div.overlay {
  position: fixed;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #000000c0;
}
div.overlay .close_btn {
  position: absolute;
  top: 5%;
  right: 5%;
  z-index: 10;
  background-color: #797979 !important;
  color: #ffffff !important;
  border: #ffffff !important; 
}
div.overlay .close_btn:hover {
  background-color: #c9c9c9 !important;
  color: #000000 !important;
}
div.overlayInner {
  width: 70%;
  height: 90vh;
  margin: 0 auto;
  margin-top: 10vh;
}
div.overlayInner .el-carousel {
  width: 100%;
  height: 85%;
}
div.overlayInner .el-carousel__container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
div.overlayInner .el-carousel__item:nth-child(2n + 1) {
  background-color: #00000060;
}
div.overlayInner .el-image {
  width: 100%;
  height: 100%;
}
div.overlayInner .el-image img {
  object-fit: contain;
  height: 100%;
}
@media screen and (max-width: 1200px) {
  div.overlayInner {
    width: 100%;
    height: 110vh;
    margin: 0;
  }
}
@media screen and (max-width: 600px) {
  div.overlay .close_btn {
    top: 2%;
    right: 2%;
    padding: 8px;
  }
}
@media screen and (max-width: 440px) {
  div.overlayInner .el-carousel {
    height: 90vh;
  }
}
</style>